/**
 * 会话页 输入框 简版
 */

import { useMemo, useState, forwardRef, useImperativeHandle } from 'react';
import EE from '@/common/event';
import { Divider } from 'antd';
import Microphone from '@/components/microphone';
import ChatEditor from '@/components/chat/ChatEditor';
import SendButton from '@/components/chat/SendButton';
import StopButton from '@/components/chat/StopButton';
import { observer } from 'mobx-react-lite';
import chatStoreManager from '@/store/chat/manager';
import appLogger from '@public/log/monitor';
import { useEffect } from 'react';
import { useRef } from 'react';
import client from '@/store/client';
import './index.scss';
import fieldCategoryStore from '@/components/field-category/store';
import globalStore from '@/store/global';
import Cascaders from '@/components/chat/ChatInput/Gaokaoxk/Cascaders';
import GaokaoxkStore from '@/components/chat/ChatInput/Gaokaoxk/GaokaoxkStore';
import { CloseOutlined } from '@ant-design/icons';
import Tooltip from '@/ui/tooltip';

function getInputTextWidth(inputElement) {
  const tempElement = document.createElement('span');
  tempElement.style.visibility = 'hidden';
  tempElement.style.whiteSpace = 'pre';
  tempElement.style.font = window.getComputedStyle(inputElement).font;
  tempElement.textContent = inputElement.value;
  document.body.appendChild(tempElement);
  const width = tempElement.getBoundingClientRect().width;
  document.body.removeChild(tempElement);
  return width;
}

function Component(props, ref) {
  const { className, agentInfo, canAborting, isAITyping, onSend } = props;
  const $refInput = useRef(null);
  const chatStore = chatStoreManager.current || {};
  const [value, setValue] = useState('');
  const [textareaWidth, setTextareaWidth] = useState(false);
  const [isTextareaRows, setIsTextareaRows] = useState(false);
  const isAllFieldsValid = () => {
    // 检查所有字段是否有值
    const allFieldsFilled = Object.entries(GaokaoxkStore.requiredFields).every(
      ([key, value]) => {
        if (key === 'optional') {
          // 如果是 optional，检查长度是否等于 maxCount
          if (value.length !== GaokaoxkStore.requiredFields.maxCount) {
            return false;
          }
          return true;
        }
        if (Array.isArray(value)) {
          // 如果是数组，检查是否非空
          if (value.length === 0) {
            return false;
          }
          return true;
        }
        // 对于其他类型，检查是否非空
        if (value === '') {
          return false;
        }
        return true;
      }
    );

    return allFieldsFilled;
  };
  const disabled = useMemo(() => {
    if (isAllFieldsValid()) {
      return false;
    } else {
      return props.disabled || value.trim().length == 0;
    }
  }, [props.disabled, value, GaokaoxkStore.requiredFields]);
  const btnDisabled = disabled;

  const isGaokao = useMemo(() => {
    if (
      globalStore?.cloudConfig?.assistantGaokaoAgentList?.includes(
        agentInfo?.id
      )
    ) {
      // 智能体首页，根据云控来控制是否显示高考信息输入项
      return true;
    }
    return fieldCategoryStore.curCategoryIdx === 0;
  }, [
    fieldCategoryStore.curCategoryIdx,
    globalStore?.cloudConfig?.assistantGaokaoAgentList,
    agentInfo?.id,
  ]);

  /** 会话中发送消息的方法，prompt type 可选 */
  const handleSend = (prompt, type) => {
    // 如果有使用 prompt 则不走下面条件
    if (!prompt) {
      if (btnDisabled) {
        return;
      }
    }
    if (isAITyping) {
      return;
    }

    chatStoreManager.setNewChatLogData({
      key: appLogger.getRouterName(),
      input_type: 'text_inout', // 文字输入
    });

    const params = {
      value: value.trim() || (isGaokao && GaokaoxkStore.prompt),
      kwargs: {
        gaokao_intention: GaokaoxkStore.getFields(),
      },
    };
    // 如果通过上传文件后的 总结关键点、生成大纲等提示词发送
    if (prompt && type) {
      params.value = prompt;
      params.fileType = type;
    }

    onSend?.(params);
    // setValue('');

    setTimeout(() => {
      setIsTextareaRows(
        textareaWidth > 0 &&
          getInputTextWidth($refInput?.current?.value) > textareaWidth - 8
      );
    }, 20);
  };

  useEffect(() => {
    const textarea = $refInput?.current?.value;
    if (textarea) {
      setTextareaWidth(textarea.clientWidth);
    }
  }, [$refInput]);

  useImperativeHandle(ref, () => ({
    // 用于外部修改输入框的值（当前是替换)
    setValue(value) {
      setValue(value);
    },
  }));

  const clearStatus = () => {
    setValue('');
  };

  useEffect(() => {
    EE.on('send_message_sucess', clearStatus);
    return () => {
      EE.off('send_message_sucess', clearStatus);
    };
  }, []);

  return (
    <div
      className={[
        'chat__input',
        'w-full relative',
        'rounded-12px',
        'border-1px border-black border-opacity-16 bg-white',
        className,
      ]}
      style={{
        // padding: '1px',
        boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.10)',
        boxSizing: 'border-box',
      }}
    >
      <div
        className={`w-full p-12px bg-input-bg-normal overflow-hidden rounded-24px py-12px`}
      >
        <div
          className={`chat-input-warp w-full flex gap-14px ${isTextareaRows ? 'textarea-rows' : ''}`}
        >
          <div className="chat-input-textarea pl-4px w-full flex items-center">
            {isGaokao ? (
              <Cascaders isRightAligned={false} />
            ) : (
              <ChatEditor
                ref={$refInput}
                className="!p-0px nw-scrollbar !min-h-22px !leading-22px"
                autoSize={{ minRows: 1, maxRows: 10 }}
                value={value}
                placeholder={'提出后续问题...'}
                onChange={value => {
                  setValue(value);
                  setTimeout(() => {
                    setIsTextareaRows(
                      textareaWidth > 0 &&
                        getInputTextWidth($refInput?.current?.value) >
                          textareaWidth - 8
                    );
                  }, 20);
                }}
                onPressEnter={handleSend}
              />
            )}
          </div>
          <div className={`flex items-end justify-between`}>
            <div className="flex items-center chat-input-tools">
              {isGaokao ? (
                ''
              ) : (
                <>
                  <div className="flex items-center">
                    <Microphone
                      onChange={value => {
                        setValue(v => v + value);
                        EE.emit('chat_input_focus');
                      }}
                    />
                  </div>
                  <Divider
                    className={`!mx-16px !ml-8px ${!client.supportMic ? 'hidden-in-client' : ''}`}
                    type="vertical"
                  />
                </>
              )}
              {!isGaokao ? (
                ''
              ) : (
                <div
                  className={`absolute top-[10px]  cursor-pointer w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-all`}
                  onClick={() => {
                    fieldCategoryStore.reset();
                    GaokaoxkStore.clearRequiredFields();
                    GaokaoxkStore.clearOptionalFields();
                  }}
                >
                  <CloseOutlined className="text-gray-600 " />
                </div>
              )}

              <div className="inline-block cursor-pointer">
                {canAborting && isAITyping ? (
                  <StopButton
                    className="flex-shrink-0 size-32px flex justify-center items-center"
                    onClick={e => {
                      e.stopPropagation();
                      chatStore.abort();
                    }}
                  />
                ) : (
                  <Tooltip
                    title={
                      btnDisabled && isGaokao ? '请填完必填项再提交哦~' : ''
                    }
                    // color="#FFFFFF"
                    overlayStyle={{ zIndex: 9999 }} // 确保层级最高
                    // overlayInnerStyle={{
                    //   backgroundColor: '#FFFFFF',
                    //   color: '#000000',
                    //   border: '1px solid #E0E0E0',
                    //   borderRadius: '4px',
                    //   boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    // }}
                  >
                    <div>
                      <SendButton
                        disabled={btnDisabled}
                        onClick={e => {
                          e.stopPropagation();
                          handleSend();
                        }}
                        className="flex-shrink-0 size-32px flex justify-center items-center"
                      />
                    </div>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const SimpleInput = observer(forwardRef(Component));
export default SimpleInput;
